var scope_0 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/04b99fd50fe3a120faccad7dd96fc3d6.js').default;

var scope_1 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/223a8844e4c9ad912ca25bd1b569dd3c.js').default;

var scope_2 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3c2c47e2052c31e89c596f30427d817c.js').default;

var scope_3 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6dc319e300404b10f237a3be831f158c.js').default;

var scope_4 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/798c065560722841042af786d1efc518.js').default;

var scope_5 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/89009765cc1c6e8ba5bc0011299955a8.js').default;

var scope_6 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8f776f5c8321ea85fd6a73cc8b2da115.js').default;

var scope_7 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/be18b067f73eb95ed47ce0c6e3d50e27.js').default;

var scope_8 = require('/Users/sagivbengiat/cloned_projects/react-elastic-carousel/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}